<template>
  <single-selection-list :items="items" :is-loading="isLoading" :pagination="pagination" @page-number-select="onPageNumberSelect">
    <template slot="is-empty">
      {{ $t('sentence.no{label}For{searchTerm}', { label: $t('label.context'), searchTerm: filter }) }}
    </template>
  </single-selection-list>
</template>

<script>

import userService from 'Services/UserService'

import { Filter } from '@/classes/filters'
import PaginationRequest from '@/classes/PaginationRequest'

import SingleSelectionList from '@/views/Context/Components/SingleSelectionList.vue'

export default {
  name: 'SearchSelector',

  components: { SingleSelectionList },

  model: {
    prop: 'filter'
  },

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    liveOnly: {
      type: Boolean,
      default: false
    },
    filter: {
      type: String
    }
  },

  data () {
    return {
      isLoading: false,

      items: [],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0
      },

      cancelToken: null
    }
  },

  mounted () {
    this.$watch(() => this.filter, filter => filter && this.onSearch(filter), { immediate: true })
  },

  methods: {
    onSearch (filter) {
      this.$store.dispatch('removeSelections')

      this.getContext(filter)
    },

    onPageNumberSelect (pageNumber) {
      this.pagination.pageNumber = pageNumber

      this.getContext(this.filter)
    },

    getContext (filter) {
      this.isLoading = true

      if (this.cancelToken) {
        this.cancelToken.cancel()
      }

      const { request, cancelToken } = userService.getContext(new PaginationRequest(this.pagination.pageNumber, this.pagination.pageSize, [new Filter(null, 'searchTerm', filter), new Filter(null, 'liveOnly', this.liveOnly)]))
      this.cancelToken = cancelToken

      request.then(result => {
        this.items = result.data
        this.pagination.totalCount = parseInt(result.totalCount)
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
